import moment from "moment";

import { authGet } from "@api";
import { TimeLookbackRange } from "@types";
import { calculateLookbackSeconds } from "@utils";

import { CategorySummaryResponse } from "@pages/overview/types";

export const fetchCategorySummaries = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  reposFilter: string[],
  until: number = moment().unix()
): Promise<CategorySummaryResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  const reposParam =
    reposFilter.length > 0 ? `&repo=${reposFilter.join(",")}` : "";

  return authGet<CategorySummaryResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/categories?since=${since}&until=${until}${reposParam}`
  );
};
